import { useCallback } from "react"
import * as EventTypeEnum from "../event-type-enum";
import useEventBusListener from "./use-event-bus-listener";

function useOnEntityUpdated(entityType = null, entityId = null, onUpdated = ({ entityType, entityId, entityData }) => { }) {

    const entityTypeFilter = entityType;
    const entityIdFilter = entityId;
    const eventReceived = useCallback(({ entityId, entityType, entityData }) => {
        if ((entityTypeFilter === null || entityTypeFilter === undefined || entityType === entityTypeFilter) &&
            (entityIdFilter === null || entityIdFilter === undefined || entityId === entityIdFilter))
            onUpdated({ entityId, entityType, entityData });
    }, [onUpdated, entityTypeFilter, entityIdFilter]);

    useEventBusListener(EventTypeEnum.EntityUpdated, eventReceived);

}
export default useOnEntityUpdated;